import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import { withLanguage } from '../../context/LanguageContext';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

class FeaturesTiles extends React.Component {

  render() {
    const { text } = this.props;

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'features-tiles section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'features-tiles-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
      'tiles-wrap',
      pushLeft && 'push-left'
    );

    const sectionHeader = {
      title: '',
      paragraph: ''
    };

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content" />
            <div className={tilesClasses}>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="mb-16">
                      <Image
                        src={require('./../../assets/icons/New_low_cost_icon_1771221559353.png')}
                        alt="Features tile icon 01"
                        width={96}
                        height={96} />
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      {text('低コスト', 'Low cost')}
                    </h4>
                    <p className="m-0 text-sm">
                      {text('月額5,000円からの低コストプラン', 'Affordable plans starting at ¥5,000 per month')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="100">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="mb-16">
                      <Image
                        src={require('./../../assets/icons/New_auto_structuring_icon_1771221574617.png')}
                        alt="Features tile icon 02"
                        width={96}
                        height={96} />
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      {text('自動構造化', 'Automatic structuring')}
                    </h4>
                    <p className="m-0 text-sm">
                      {text('生成AIによる構造化提案', 'Generative AI proposes structured data')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="mb-16">
                      <Image
                        src={require('./../../assets/icons/New_importance_classification_icon_1771221592386.png')}
                        alt="Features tile icon 03"
                        width={96}
                        height={96} />
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      {text('重要度分類', 'Importance classification')}
                    </h4>
                    <p className="m-0 text-sm">
                      {text('生成AIによる各データの重要度分類', 'Generative AI classifies the importance of each field')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="300">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="mb-16">
                      <Image
                        src={require('./../../assets/icons/New_icon_template_1771221484269.png')}
                        alt="Features tile icon 04"
                        width={96}
                        height={96} />
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      {text('テンプレート化', 'Reusable templates')}
                    </h4>
                    <p className="m-0 text-sm">
                      {text('構造及び重要度のテンプレート化', 'Save data structures and importance rules as templates')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="400">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="mb-16">
                      <Image
                        src={require('./../../assets/icons/New_icon_csv_1771221499746.png')}
                        alt="Features tile icon 05"
                        width={80}
                        height={80} />
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      {text('表のCSV化', 'Tables to CSV')}

                    </h4>
                    <p className="m-0 text-sm">
                      {text('矩形選択による表のCSV化', 'Convert selected table regions to CSV')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="500">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="mb-16">
                      <Image
                        src={require('./../../assets/icons/New_icon_security_1771221514700.png')}
                        alt="Features tile icon 06"
                        width={96}
                        height={96} />
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      {text('ゼロリテンション', 'Zero retention')}
                    </h4>
                    <p className="m-0 text-sm" style={{ whiteSpace: 'nowrap' }}>
                      {text('実データを保存しないセキュアなシステム', 'A secure system that does not retain source data')}
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    );
  }
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default withLanguage(FeaturesTiles);
